const PUBLIC_VAPID_KEY = process.env.REACT_APP_PUBLIC_VAPID_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function subscribeUserToPush(apiBaseUrl, token) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('Push messaging is not supported in this browser.');
    return;
  }

  if (!PUBLIC_VAPID_KEY) {
    console.warn('Push messaging public VAPID key is not configured in .env.');
    return;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    
    let permission = Notification.permission;
    if (permission === 'default') {
      permission = await Notification.requestPermission();
    }
    
    if (permission !== 'granted') {
      console.warn('Notification permission was not granted.');
      return;
    }

    const subscribeOptions = {
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(PUBLIC_VAPID_KEY)
    };

    const subscription = await registration.pushManager.subscribe(subscribeOptions);
    console.log('✅ Push Subscription created (Manager):', subscription);

    const response = await fetch(`${apiBaseUrl}/api/auth/save-push-subscription`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ subscription })
    });

    if (response.ok) {
      console.log('✅ Push subscription saved to backend successfully (Manager).');
    } else {
      console.error('❌ Failed to save push subscription to backend (Manager):', response.statusText);
    }
  } catch (error) {
    console.error('❌ Error during push subscription registration (Manager):', error);
  }
}
